'use strict';

module.exports = function isAndroid(ua) {
  ua = ua || global.navigator.userAgent;
  return /Android/.test(ua);
};



//////////////////
// WEBPACK FOOTER
// ./~/@braintree/browser-detection/is-android.js
// module id = 636
// module chunks = 0